import { X } from 'lucide-react';
import { DialogBackdrop } from '../../../../../components/ui/dialog-backdrop';
import { useTenants } from '../../../../../components/tenant-selector/useTenants';
import styles from './templates-table.module.css';

interface SubscribedTenantsDialogProps {
  templateName: string;
  activeBusinessIds: string[];
  onClose: () => void;
  /** Heading, e.g. "Tenants using" (automations) or "Synced tenants" (segments). */
  title: string;
}

export function SubscribedTenantsDialog({
  templateName,
  activeBusinessIds,
  onClose,
  title,
}: SubscribedTenantsDialogProps) {
  const { data: roster } = useTenants();
  const tenantNameById = new Map((roster ?? []).map(tenant => [tenant.id, tenant.name]));

  const tenants = activeBusinessIds
    .map(id => ({ id, name: tenantNameById.get(id) ?? id }))
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

  const countLabel = `${tenants.length} ${tenants.length === 1 ? 'tenant' : 'tenants'}`;

  return (
    <>
      <DialogBackdrop onClose={onClose} />
      <dialog className={styles.dialog} open aria-label={`${title} ${templateName}`}>
        <header className={styles.header}>
          <div>
            <h2>{title}</h2>
            <p>
              {templateName} · {countLabel}
            </p>
          </div>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
            <X className={styles.closeIcon} />
          </button>
        </header>
        <ul className={styles.tenants}>
          {tenants.map(tenant => (
            <li key={tenant.id}>{tenant.name}</li>
          ))}
        </ul>
      </dialog>
    </>
  );
}
